export const getDefaultStateAgenciesReducer = state => state.defaultStateAgencies;

export const getDefaultStateAgencies = state =>
  getDefaultStateAgenciesReducer(state).defaultStateAgencies;
export const getDefaultStateAgenciesReadyStatus = state =>
  getDefaultStateAgenciesReducer(state).isReady;
